import { render } from "./management.vue?vue&type=template&id=6e54a1c8"
import script from "./management.vue?vue&type=script&lang=js"
export * from "./management.vue?vue&type=script&lang=js"

import "./management.vue?vue&type=style&index=0&id=6e54a1c8&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__